import { Component, OnInit } from '@angular/core';
import { dashboardSettings } from './dashboardSettings';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  public settings = dashboardSettings;

  constructor() {}

}
